export class BookmarkNotFoundError extends Error {
  readonly code = 'bookmark-not-found';

  constructor() {
    super('bookmark-not-found');
    this.name = 'BookmarkNotFoundError';
  }
}

export class BookmarkStaleEditError extends Error {
  readonly code = 'bookmark-stale-edit';

  constructor() {
    super('bookmark-stale-edit');
    this.name = 'BookmarkStaleEditError';
  }
}
